<script>
import { formAutoCompleteConfig } from "@/components/base/conf";
import popupMultiple from "@/components/base/popup/popupMultiple";

export default {
  name: "formMultiple",
  components: {
    popupMultiple
  },
  props: {
    //值
    value: {
      type: Array,
      default: () => []
    },
    //标题
    title: {
      type: String,
      default: ""
    },
    //标题 宽度
    titleWidth: {
      type: String,
      default: ""
    },
    //提示
    placeholder: {
      type: String,
      default: "请选择"
    },
    //数据
    options: {
      type: Array,
      default: () => []
    },
    //是否开启搜索
    search: {
      type: Boolean,
      default: false
    },
    //搜索 过滤参数
    searchFilter: {
      type: [String, Array, Function],
      default: () => formAutoCompleteConfig.searchFilter
    },
    //搜索框 提示文字
    searchPlaceholder: {
      type: String,
      default: ""
    },
    //必填
    required: {
      type: Boolean,
      default: false
    },
    //只读
    readonly: {
      type: Boolean,
      default: false
    },
    //数据value 参数
    valueField: {
      type: String,
      default: formAutoCompleteConfig.valueField
    },
    //数据text 参数
    labelField: {
      type: String,
      default: formAutoCompleteConfig.labelField
    },
    //值 样式
    fieldButtonType: {
      type: String,
      default: "primary"
    },
    //确认 描述
    confirmButtonText: {
      type: String,
      default: "确认"
    },
    //取消 描述
    cancelButtonText: {
      type: String,
      default: "取消"
    },
    //最大数量
    max: {
      type: [String, Number],
      default: null
    },
    //最大数量提示
    maxPlaceholder: {
      type: String,
      default: "最大选择数量:"
    },
    //最大高度
    maxHeight: {
      type: String,
      default: "60%"
    },
    //是否在点击遮罩层后关闭
    closeOnClickOverlay: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      visible: false,
      realValue: []
    };
  },
  watch: {
    realValue(e) {
      if (this.realValue != this.value) {
        this.$emit("input", e);
      }
    },
    value(e) {
      if (this.realValue != this.value) {
        this.realValue = e;
      }
    }
  },
  created() {
    this.realValue = this.value;
  },
  methods: {
    /**
     * @description: 获取值
     * @param {*}
     * @return {*}
     */
    getValue() {
      return this.realValue;
    },
    /**
     * @description: 赋值
     * @param {*}
     * @return {*}
     */
    setValue(e) {
      this.realValue = e;
    },
    /**
     * @description: 显示
     * @param {*}
     * @return {*}
     */
    show() {
      let { readonly, disabled } = this;
      if (!(readonly || disabled)) {
        this.visible = true;
      }
    },
    /**
     * @description: 确认
     * @param {*} e
     * @return {*}
     */
    confirm(e) {
      let { valueField } = this;
      let rows = [];
      this.options.map(p => {
        if (e && e.includes(p[valueField])) {
          rows.push(p);
        }
      });
      this.realValue = e;
      this.$emit("change", e, rows);
    },
    /**
     * @description: 取消
     * @param {*}
     * @return {*}
     */
    cancel() {
      this.visible = false;
      if (!this.required) {
        this.valueUpdate([]);
      }
    },
    /**
     * @description: 输入框 渲染
     * @param {*}
     * @return {*}
     */
    fieldRender() {
      let { readonly, disabled } = this;
      const btns = this.buttonRender();
      let arrow;
      readonly = readonly || disabled;
      if (!readonly) {
        arrow = <i class="van-icon van-icon-arrow" />;
      }
      return (
        <div
          class={`van-cell van-field ${
            this.required ? "van-cell--required" : ""
          }`}
          onClick={this.show}
        >
          <div
            class="van-cell__title van-field__label"
            style={{ width: this.titleWidth }}
          >
            <span>{this.title}</span>
          </div>
          <div class="van-cell__value van-field__value">
            <div class="van-field__body">{btns}</div>
            <div class="van-field__right-icon">{arrow}</div>
          </div>
        </div>
      );
    },
    /**
     * @description: 显示图标 渲染
     * @param {*}
     * @return {*}
     */
    buttonRender() {
      let { realValue, valueField, labelField, fieldButtonType } = this;
      let btns = [];
      this.options.map(p => {
        if (realValue && realValue.includes(p[valueField])) {
          btns.push(
            <van-button size="mini" class="btn" type={fieldButtonType}>
              {p[labelField]}
            </van-button>
          );
        }
      });
      return btns;
    },
    /**
     * @description: 弹窗 渲染
     * @param {*}
     * @return {*}
     */
    popupMultipleRender() {
      const { popupLabelField } = this;
      const option = {
        props: {
          value: this.realValue,
          visible: this.visible,
          search: this.search,
          searchFilter: this.searchFilter,
          searchPlaceholder: this.searchPlaceholder,
          options: this.options,
          valueField: this.valueField,
          labelField: popupLabelField ? popupLabelField : this.labelField,
          cancelButtonText: this.cancelButtonText,
          confirmButtonText: this.confirmButtonText,
          max: this.max,
          maxPlaceholder: this.maxPlaceholder,
          maxHeight: this.maxHeight,
          closeOnClickOverlay: this.closeOnClickOverlay
        },
        on: {
          input: e => {
            this.visible = e;
          },
          // "update:keys": e => {
          //   this.confirm(e)
          // },
          confirm: this.confirm
        }
      };
      return <popupMultiple {...option} />;
    }
  },
  render() {
    return (
      <div>
        {this.fieldRender()}
        <div />
        {this.popupMultipleRender()}
      </div>
    );
  }
};
</script>

<style lang="less" scoped>
/deep/.van-cell__value {
  text-align: left;
  line-height: initial;
  display: flex;
  .van-field__body {
    display: inline-block;
    flex: 1;
    .btn {
      padding: 0 4px;
      margin: 3px 4px 3px 0;
      float: left;
      height: 18px;
      line-height: 18px;
    }
  }
}

/deep/.van-field__right-icon {
  line-height: 24px;
}
</style>
